/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Replicate_Api_TokenInputs */

const en_admin_settings_fields_replicate_api_token = /** @type {(inputs: Admin_Settings_Fields_Replicate_Api_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Token`)
};

/**
* | output |
* | --- |
* | "API Token" |
*
* @param {Admin_Settings_Fields_Replicate_Api_TokenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_replicate_api_token = /** @type {((inputs?: Admin_Settings_Fields_Replicate_Api_TokenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Replicate_Api_TokenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_replicate_api_token(inputs)
});
export { admin_settings_fields_replicate_api_token as "admin.settings.fields.replicate_api_token" }